import React, { useState, useEffect, useCallback } from 'react'
import PropTypes from 'prop-types'
import strings from 'utils/strings'
import { compose } from 'ramda'
import { escape, unescape } from 'utils/utils'

import { EditorState, convertToRaw, ContentState } from 'draft-js'
import htmlToDraft from 'html-to-draftjs'
import draftToHtml from 'draftjs-to-html'

import { Editor } from 'react-draft-wysiwyg'
import { Button } from 'components/patterns'
import { EditorWrap } from './WYSIWYG.style'

import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css'

const convertToHTML = compose(draftToHtml, convertToRaw)

const WYSIWYG = ({ value, onSave, onChange, options, editorStyles }) => {
  const [editorState, setEditorState] = useState(null)

  const setEditorStateCallback = useCallback(() => {
    const contentBlock = htmlToDraft(unescape(value))
    const contentState = ContentState.createFromBlockArray(
      contentBlock.contentBlocks
    )
    const editorStartingState = EditorState.createWithContent(contentState)
    setEditorState(editorStartingState)
  }, [value])

  useEffect(() => {
    setEditorStateCallback()
  }, [setEditorStateCallback])

  const handleEditorStateChange = (state) => {
    setEditorState(state)
    onChange(convertToHTML(state.getCurrentContent()))
  }

  const handleSaveOnClick = () => {
    const html = convertToHTML(editorState.getCurrentContent())
    onSave(escape(html))
  }

  return (
    <>
      <EditorWrap editorStyles={editorStyles}>
        <Editor
          editorState={editorState}
          onEditorStateChange={handleEditorStateChange}
          toolbar={options}
        />
      </EditorWrap>
      <Button type="primary" onClick={handleSaveOnClick}>
        {strings.save}
      </Button>
    </>
  )
}

WYSIWYG.propTypes = {
  value: PropTypes.string, // string or HTML string
  onSave: PropTypes.func,
  onChange: PropTypes.func,
  options: PropTypes.object,
  editorStyles: PropTypes.object,
}

export default WYSIWYG
